<template>
  <svg
    height="512pt"
    viewBox="0 -21 512 512"
    width="512pt"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m16 277.332031c-1.984375 0-3.96875-.363281-5.867188-1.109375-6.121093-2.410156-10.132812-8.320312-10.132812-14.890625v-160c0-6.570312 4.011719-12.480469 10.132812-14.890625 6.144532-2.410156 13.078126-.851562 17.558594 3.96875l74.664063 80c5.761719 6.144532 5.761719 15.679688 0 21.824219l-74.664063 80c-3.09375 3.328125-7.339844 5.097656-11.691406 5.097656zm16-135.402343v78.804687l36.777344-39.402344zm0 0"
    ></path>
    <path
      d="m474.667969 128h-330.667969c-20.585938 0-37.332031-16.746094-37.332031-37.332031v-53.335938c0-20.585937 16.746093-37.332031 37.332031-37.332031h330.667969c20.585937 0 37.332031 16.746094 37.332031 37.332031v53.335938c0 20.585937-16.746094 37.332031-37.332031 37.332031zm-330.667969-96c-2.945312 0-5.332031 2.390625-5.332031 5.332031v53.335938c0 2.941406 2.386719 5.332031 5.332031 5.332031h330.667969c2.941406 0 5.332031-2.390625 5.332031-5.332031v-53.335938c0-2.941406-2.390625-5.332031-5.332031-5.332031zm0 0"
    ></path>
    <path
      d="m474.667969 469.332031h-330.667969c-20.585938 0-37.332031-16.746093-37.332031-37.332031v-160c0-20.585938 16.746093-37.332031 37.332031-37.332031h330.667969c20.585937 0 37.332031 16.746093 37.332031 37.332031v160c0 20.585938-16.746094 37.332031-37.332031 37.332031zm-330.667969-202.664062c-2.945312 0-5.332031 2.386719-5.332031 5.332031v160c0 2.945312 2.386719 5.332031 5.332031 5.332031h330.667969c2.941406 0 5.332031-2.386719 5.332031-5.332031v-160c0-2.945312-2.390625-5.332031-5.332031-5.332031zm0 0"
    ></path>
    <path
      d="m309.332031 128c-8.832031 0-16-7.167969-16-16v-96c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0"
    ></path>
    <path
      d="m309.332031 469.332031c-8.832031 0-16-7.167969-16-16v-202.664062c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v202.664062c0 8.832031-7.167969 16-16 16zm0 0"
    ></path>
    <path
      d="m496 368h-373.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h373.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "editPicksIcon"
};
</script>

<style scoped>
svg {
  fill: currentColor;
}
</style>
